export const LINEAREALTIME = 'LINEAREALTIME'